const isHereAutocompleteOption = (option) => {
    return option.value.responseFrom === 'here';
};
const isGeogosAutocompleteOption = (option) => !isHereAutocompleteOption(option);

export { isGeogosAutocompleteOption, isHereAutocompleteOption };
//# sourceMappingURL=types.js.map
